import React from "react";
import './SearchBar.css';
const SearchBar = (props) => {
    const { handleSearch } = props
    return (
        <div className="searchPlayers">
            <input type="text"
                className="searchBar"
                placeholder="Search Players"
                onChange={handleSearch} />
        </div>
    )
}

export default SearchBar;